import type { CityConfig } from "@/pages/city-template/types";

export const ithacaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Ithaca",
  state: "New York",
  stateAbbr: "NY",
  slug: "ithaca",
  route: "/ithaca",
  title: "Emergency Passport Ithaca, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription:
    "Emergency passport Ithaca NY — same day, 24-hour, and 3-5 day expedited passport processing for Tompkins County. Fast Passport Center serves Ithaca, Cornell University, Cortland, and all Finger Lakes communities.",
  h1: "Emergency & Expedited Passport Services in Ithaca, NY",
  heroSubtitle:
    "Ithaca's fast passport solution — from the home of Cornell University to the heart of the Finger Lakes. Whether you're flying out of Ithaca Tompkins International or heading to Syracuse, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days. A+ BBB rated, registered State Dept. courier. No office visit required.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Ithaca%20New%20York%20scenic%20view%20of%20Cayuga%20Lake%20from%20Cornell%20University%20campus%2C%20historic%20gothic%20buildings%20and%20clock%20tower%2C%20fall%20foliage%20on%20the%20Finger%20Lakes%20hillside%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20beautiful%20college%20town%20and%20lake%20landscape&width=1600&height=700&seq=ny-ithaca-hero-001&orientation=landscape",
  heroImageAlt: "Ithaca New York scenic view of Cayuga Lake from Cornell University campus with fall foliage",
  geoPosition: "42.4430; -76.5019",
  geoPlacename: "Ithaca, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~220 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Ithaca", zips: "14850, 14851, 14852, 14853" },
    { name: "Cortland", zips: "13045, 13046" },
    { name: "Trumansburg", zips: "14886" },
    { name: "Lansing", zips: "14882" },
    { name: "Dryden", zips: "13053" },
    { name: "Groton", zips: "13073" },
    { name: "Auburn", zips: "13021, 13022, 13024" },
    { name: "Elmira", zips: "14901, 14902, 14903, 14904, 14905" },
    { name: "Corning", zips: "14830, 14831" },
    { name: "Syracuse", zips: "13201-13210" },
    { name: "Binghamton", zips: "13901-13905" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Ithaca travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Cornell & Ithaca College Ready",
      desc: "Study abroad, international research conferences, visiting scholars — we understand the academic passport calendar at Cornell and IC better than anyone.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Tompkins & Finger Lakes Region",
      desc: "Ithaca, Cornell, Cortland, and the entire Finger Lakes region — we serve all of central New York with the same fast, reliable processing.",
    },
  ],
  internalLinks: [
    { name: "New York City", route: "/new-york-city" },
    { name: "Syracuse", route: "/syracuse" },
    { name: "Buffalo", route: "/buffalo" },
    { name: "Rochester", route: "/rochester" },
    { name: "Albany", route: "/albany-ny" },
    { name: "Binghamton", route: "/binghamton" },
    { name: "Elmira", route: "/elmira" },
    { name: "Corning", route: "/corning" },
    { name: "New York State", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote:
    "Fast Passport Center serves Ithaca and all of the Finger Lakes as a remote courier service. We do not have a physical office in Ithaca, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Ithaca area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Ithaca and all of Tompkins County. From the Cornell University campus to the shores of Cayuga Lake, from Cortland to Trumansburg — we serve the Finger Lakes with the same fast, reliable processing that keeps this academic community connected to the world.",
  nearbyCitiesIntro:
    "We proudly serve Ithaca and all surrounding communities across Tompkins County and the Finger Lakes region. Whether you're in Cortland, Trumansburg, Lansing, or Dryden, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Ithaca customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing. Most Cornell and Ithaca College travelers complete everything online and ship documents overnight.",
  mistakesIntro:
    "These are the most common mistakes Ithaca travelers make when applying for an expedited passport. Avoiding them saves weeks of delays — especially during the compressed academic calendar.",
  testimonialsIntro:
    "Ithaca and Finger Lakes travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Ithaca. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before a Cornell semester in London, an emergency passport for a research conference in Tokyo, or a first-time passport for an Ithaca College study-abroad student — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Last-minute Cornell research conference in Tokyo? Ithaca College program starting in London next week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Ithaca-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Ithaca residents renew fast — no agency visit required for most renewals. Perfect for Cornell faculty, Ithaca College students, and Finger Lakes families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Ithaca residents through every step — from Collegetown to the Commons to Trumansburg — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Cornell study abroad or Finger Lakes travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Finger Lakes family vacation or Ithaca family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Cornell researchers with overlapping visa applications, visiting scholars, and Ithaca professionals who travel internationally on short notice.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Ithaca-area travelers through the process so your academic travel or Finger Lakes vacation stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular for Ithaca travelers heading to Toronto and Montreal.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Ithaca NY", description: "Urgent passport processing for Ithaca travelers with immediate departure needs from Ithaca Tompkins International Airport." },
    { name: "Expedited Passport Renewal Ithaca NY", description: "Fast passport renewal for Ithaca residents with a previously-issued passport." },
    { name: "First-Time Passport Ithaca NY", description: "New passport application services for Ithaca residents applying for their first passport." },
    { name: "Child Passport Ithaca NY", description: "Minor passport services for Tompkins County families with children under 16." },
    { name: "Name Change Passport Ithaca NY", description: "Passport name correction after marriage, divorce, or legal name changes for Ithaca residents." },
    { name: "Second Passport Ithaca NY", description: "Second passport services for Cornell researchers and Ithaca frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Dr. Emily W.",
      location: "Cornell University, Ithaca",
      rating: 5,
      text: "Needed my passport renewed for a conference in Paris. Fast Passport Center processed it in 4 days. They handled everything while I was teaching. Perfect for busy academics who cannot afford downtime.",
      service: "Expedited Passport",
    },
    {
      name: "Marcus T.",
      location: "Ithaca Commons",
      rating: 5,
      text: "Got a last-minute opportunity to study abroad at King's College London. Fast Passport Center got my new passport in 5 days. They guided me to the right acceptance facility and reviewed all my docs.",
      service: "New Passport",
    },
    {
      name: "Sarah K.",
      location: "Trumansburg, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center for a Finger Lakes wine tour in France. I chose the 10-day Smart Saver option and it arrived in 7 days. Great service for Finger Lakes residents.",
      service: "Passport Renewal",
    },
    {
      name: "Prof. James L.",
      location: "Ithaca College",
      rating: 5,
      text: "Third time using Fast Passport Center for international research travel. As an Ithaca College professor leading study-abroad groups, I need reliability. They have never missed a deadline in three years.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "ithaca-1",
      name: "Ithaca Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "213 North Meadow Street",
      city: "Ithaca",
      state: "NY",
      zip: "14850",
      phone: "(607) 273-2828",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Ithaca",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ithaca passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "ithaca-2",
      name: "Cornell University Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "565 Dryden Road",
      city: "Ithaca",
      state: "NY",
      zip: "14850",
      phone: "(607) 273-1810",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Cornell Campus area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cornell University students, faculty, and staff. Passport acceptance services available by appointment. Extremely busy during study abroad application season.",
      icon: "ri-mail-line",
    },
    {
      id: "ithaca-3",
      name: "Cortland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "88 Main Street",
      city: "Cortland",
      state: "NY",
      zip: "13045",
      phone: "(607) 753-2002",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Cortland (~25 miles east)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Cortland, SUNY Cortland, and east of Ithaca communities. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "ithaca-4",
      name: "Tompkins County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "320 North Tioga Street",
      city: "Ithaca",
      state: "NY",
      zip: "14850",
      phone: "(607) 274-5431",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Downtown Ithaca — Tompkins County Courthouse",
      website: "https://www.tompkinscountyny.gov/countyclerk",
      websiteLabel: "Tompkins County Clerk",
      notes: "County-level passport acceptance. Convenient for all Tompkins County residents. Appointment recommended during Cornell/Ithaca College study abroad season.",
      icon: "ri-government-line",
    },
    {
      id: "ithaca-5",
      name: "Auburn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 James Street",
      city: "Auburn",
      state: "NY",
      zip: "13021",
      phone: "(315) 252-3524",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Auburn (~35 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Auburn, Cayuga County, and northern Finger Lakes communities. Alternative for Ithaca residents during peak periods.",
      icon: "ri-mail-line",
    },
    {
      id: "ithaca-6",
      name: "Elmira Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "255 Clemens Center Parkway",
      city: "Elmira",
      state: "NY",
      zip: "14901",
      phone: "(607) 734-5277",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Elmira (~35 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Elmira, Horseheads, and Chemung County. Alternative for southern Tompkins County residents during busy periods.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 220 miles to New York Passport Agency in Manhattan", fpc: "Most Ithaca travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Ithaca-Specific Guidance", agency: "Generic — no ITH/SYR airport or Cornell/Ithaca College academic calendar expertise", fpc: "Full ITH/SYR university/Finger Lakes knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming ITH Has International Flights",
      description: "Ithaca Tompkins International Airport is domestic-only with connections to hubs. Many Cornell and IC students book international flights and do not realize ITH requires a connection — meaning passport check at the connecting airport. An expired passport discovered mid-journey means a cancelled trip.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Study Abroad Acceptance-to-Departure Crunch",
      description: "Cornell and Ithaca College students often receive program acceptance 6–10 weeks before departure — barely enough time for standard passport processing. First-time applicants also need an acceptance clerk appointment, compressing the timeline further. We help students navigate this crunch.",
    },
    {
      icon: "ri-error-warning-line",
      title: "International Student Passport Complexities",
      description: "Cornell and Ithaca College host thousands of international students. Some need to renew home-country passports while studying in Ithaca — a process with unique requirements. Others need U.S. passport services for onward travel. We understand both scenarios.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Ithaca-area pharmacies and campus photo services produce photos that fail State Department standards. We catch this in review before it causes a rejection — especially critical for students on tight timelines.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Students Under 18",
      description: "College-bound students under 18 need parental consent for passport applications. Families sending forms from out of state can miss the notarization requirement. This is an automatic rejection — we guide families through it correctly.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Cornell dorm, Ithaca Commons apartment, or Finger Lakes home." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your academic or personal travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Cornell and IC students ship from the UPS Store on the Commons — no office visit needed for renewal-eligible applicants." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 220 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Ithaca?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Ithaca residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 2-9 business day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Ithaca?",
      a: "The Ithaca Main Post Office at 213 North Meadow Street is the primary passport acceptance facility. The Cornell University Post Office at 565 Dryden Road is especially convenient for students and faculty. The Tompkins County Clerk at 320 North Tioga Street also offers passport acceptance. All three get extremely busy during study abroad application season.",
    },
    {
      q: "Can I get same-day passport photos in Ithaca?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and UPS Store locations throughout Ithaca and Cortland. Cornell University also has a passport photo service on campus. We also offer photo review as part of our service.",
    },
    {
      q: "How much does an expedited passport cost in Ithaca?",
      a: "Government fees are set by the State Department: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees depend on processing speed and are typically 30-100% less than FedEx, Staples, and other third-party resellers. Call 877-253-0084 for a personalized quote.",
    },
    {
      q: "Do I need to visit the New York Passport Agency from Ithaca?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The drive from Ithaca is 220 miles each way — nearly 4 hours — making it completely impractical for most residents.",
    },
    {
      q: "What is the fastest way to renew a passport in Ithaca?",
      a: "The fastest way to renew a passport in Ithaca is through Fast Passport Center's 2-9 business day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit.",
    },
    {
      q: "Can I get a child passport expedited in Ithaca?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Ithaca and all Tompkins County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "I'm a Cornell international student — can you help with my passport?",
      a: "We primarily assist with U.S. passport applications. However, we can guide you through the process and refer you to your home country's consulate for renewals. For U.S. passport needs (such as a child born in Ithaca), we are happy to help.",
    },
    {
      q: "How do I handle my passport for Cornell study abroad?",
      a: "Cornell study abroad programs typically require a valid passport with at least 6 months remaining beyond the program end date. Start your passport application the moment you receive your program acceptance — do not wait. We help Cornell and Ithaca College students navigate the compressed timeline between acceptance and departure.",
    },
    {
      q: "Can you help with passports for Ithaca Tompkins International Airport travel?",
      a: "Yes. ITH is a regional airport with connections to major hubs. We help Ithaca travelers with expedited passports for domestic connections to international gateways. We understand the ITH-to-hub connection dynamic and can coordinate timelines around your full routing.",
    },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Ithaca & Tompkins County Residents",
    intro: "Ithaca's passport landscape is unlike any other city in New York — it's driven almost entirely by the academic calendar of two major institutions. Cornell University and Ithaca College create predictable waves of passport demand that crash against each other at specific points in the year. Here's what Ithaca travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ITH — Ithaca Tompkins International Airport",
        subtitle: "Regional airport with connections to Detroit, Philadelphia, and Washington DC",
        description: "ITH is Ithaca's home airport — small, convenient, and just minutes from both Cornell and Ithaca College. ITH offers flights to major hubs including DTW (Detroit), PHL (Philadelphia), and IAD (Washington Dulles). But ITH has no international flights — all international travel requires a connection. This creates a critical checkpoint: your passport is verified at the connecting airport, not at ITH. A passport discovered expired at DTW or PHL means you are stranded in a connecting city, not in Ithaca where you could still fix the problem.",
        tip: "Cornell students booking ITH-DTW-LHR or ITH-PHL-CDG should verify their passport before booking — not after. An expired passport discovered at Detroit Metro means you miss your London flight and Cornell's program orientation.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Cornell University — The Academic Passport Engine",
        subtitle: "Semester abroad, summer programs, research conferences, visiting scholars",
        description: "Cornell University is the single largest driver of passport demand in Ithaca. With over 25,000 students and 1,600+ faculty, Cornell's international footprint is enormous. Study abroad programs send students to 70+ countries through semester exchange, summer immersion, and faculty-led programs. Cornell's research enterprise — from Weill Cornell Medicine to the College of Engineering — generates constant international conference travel. Visiting scholars and international postdocs arrive from every continent. The result is a continuous stream of passport urgencies timed to the academic calendar.",
        tip: "Cornell's study abroad acceptance letters typically go out 6–10 weeks before departure. If you receive your acceptance in March for a June program, start your passport application the same week — standard processing takes 8–11 weeks and will not make the deadline.",
      },
      {
        icon: "ri-building-2-line",
        title: "Ithaca College — Study Abroad & Performing Arts Travel",
        subtitle: "IC London Center, international internships, performing arts tours",
        description: "Ithaca College's School of Music, Theatre, and Dance generates unique international travel patterns — student ensembles touring Europe, faculty artists performing at international festivals, and the renowned IC London Center hosting semester-long programs. IC students also pursue international internships through the Park School of Communications and the School of Business. These programs have fixed start dates tied to European academic calendars, creating hard deadlines that standard passport processing cannot meet.",
        tip: "IC London Center participants need a passport valid for at least 6 months beyond the program end date. This is a UK entry requirement — not just a State Department rule. Check your passport validity the moment you accept your spot.",
      },
      {
        icon: "ri-landscape-line",
        title: "Finger Lakes Tourism & Wine Country Travel",
        subtitle: "Seasonal tourism creates year-round international travel demand from Ithaca residents",
        description: "While the universities dominate, Ithaca's position in the heart of Finger Lakes wine country and outdoor recreation creates additional passport demand. Ithaca residents travel internationally for wine tourism (France, Italy, Argentina), outdoor adventure (New Zealand, Patagonia, Alps), and culinary tourism. The Finger Lakes region also attracts international visitors — particularly from wine-producing regions in Europe — who sometimes discover passport issues while visiting and need urgent services.",
        tip: "Finger Lakes wine enthusiasts traveling to Bordeaux, Tuscany, or Mendoza should check passport validity 3 months before departure. International wine tours and culinary trips often book 6+ months ahead — and expired passports discovered late mean losing non-refundable deposits.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Ithaca & the Canada Connection",
      description: "Ithaca is just 3.5 hours from Toronto and 4 hours from Montreal — making weekend trips to Canada common among Cornell and IC students plus Finger Lakes residents. The passport card is particularly popular here for land crossings to Ontario and Quebec. Many Ithaca residents do not realize that enhanced driver's licenses are insufficient for air travel to Canada — only a passport book or passport card works.",
    },
  },
  destinations: {
    title: "Where Ithaca Travelers Go — And Why Passports Get Urgent",
    intro: "Ithaca's academic DNA and Finger Lakes lifestyle create a distinctive international travel profile dominated by university programs, research conferences, and cultural tourism. Here are the most common destinations and urgency patterns.",
    stats: [
      { stat: "52%", label: "of Ithaca expedited requests are university-related — study abroad, research conferences, visiting scholars" },
      { stat: "6–8 Weeks", label: "average window between study abroad acceptance and program departure at Cornell and Ithaca College" },
      { stat: "Feb–Apr", label: "primary peak when spring semester study abroad applications are confirmed for summer and fall programs" },
      { stat: "30 Hours", label: "shortest turnaround for a Cornell researcher departing ITH to a Paris conference" },
    ],
    destinations: [
      { name: "United Kingdom & Ireland", context: "Cornell and IC London programs, King's College and LSE exchange, Cambridge and Oxford research collaborations, UK academic conference circuit", urgency: "Program and conference dates are fixed — discover passport issues 1–2 weeks before and you miss the semester", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Cornell in Rome program, IC performing arts in Paris, Finger Lakes wine tourism in Tuscany and Bordeaux, engineering and architecture study programs", urgency: "Summer programs book 3–4 months ahead — but students check passports only weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "Cornell Tech Berlin partnerships, engineering internships at German firms, academic conferences, Finger Lakes wine tourism to Rhine and Swiss regions", urgency: "Summer internship start dates are fixed with 6–8 week acceptance-to-departure windows", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Cornell East Asia programs, engineering research collaborations, IC Park School media internships in Tokyo and Seoul", urgency: "East Asian programs require visas in addition to passports — the timeline crunch is even tighter", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Cornell and IC spring break trips, Finger Lakes winter escape resort travel, cruise departures from Northeastern ports", urgency: "Spring break bookings made December–January with 8–10 week lead — but student passport issues surface 2–3 weeks before", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto and Montreal weekend trips, cross-border academic conferences, Finger Lakes-to-Ontario wine tourism, Quebec City cultural travel", urgency: "Weekend trips often planned with minimal notice — travelers discover passport issues day-of", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State and the Finger Lakes with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Syracuse", route: "/syracuse" },
      { name: "Binghamton", route: "/binghamton" },
      { name: "Rochester", route: "/rochester" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Ithaca", address: "222 Elmira Road, Ithaca, NY 14850", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Ithaca", address: "335 Pine Tree Road, Ithaca, NY 14850", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Ithaca Commons", address: "215 East State Street, Ithaca, NY 14850", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Cornell University — Campus Store Photo", address: "Cornell University campus, Ithaca, NY 14853", hours: "Mon–Fri 9:00 AM – 5:00 PM", website: "https://www.cornell.edu/" },
    { name: "Walmart Photo Center — Ithaca", address: "135 Fairgrounds Memorial Parkway, Ithaca, NY 14850", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Cortland", address: "133 Clinton Avenue, Cortland, NY 13045", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Ithaca", address: "Cornell University Campus Store area, Ithaca, NY 14853", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walgreens — Cortland", address: "3920 Route 281, Cortland, NY 13045", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Ithaca",
      address: "301 3rd Street, Ithaca, NY 14850",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Ithaca DMV office for license renewals and REAL ID applications. Extremely busy during Cornell move-in weeks (August/January). Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Cortland",
      address: "112 River Street, Cortland, NY 13045",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Cortland DMV office serving Cortland County and east of Ithaca residents. Often less crowded than Ithaca during university peak periods.",
      featured: false,
    },
    {
      name: "NYS DMV — Auburn",
      address: "168 Genesee Street, Auburn, NY 13021",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Auburn DMV office for Cayuga County residents. Alternative for northern Tompkins County residents during busy periods.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ITH",
      name: "Ithaca Tompkins International Airport",
      distance: "In Ithaca, NY",
      address: "1 Culligan Drive, Ithaca, NY 14850",
      note: "Ithaca's regional airport with flights to Detroit, Philadelphia, and Washington DC hubs. Perfect for Cornell and Finger Lakes travelers connecting to international gateways.",
      flightUrl: "https://www.ithacaairport.com/",
      flightLabel: "ITH Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~55 miles from Ithaca",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Major upstate New York airport with flights to major U.S. hubs and some international destinations. Popular for Ithaca travelers wanting more flight options.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
    {
      code: "ELM",
      name: "Elmira Corning Regional Airport",
      distance: "~40 miles from Ithaca",
      address: "276 Sing Sing Road, Horseheads, NY 14845",
      note: "Regional airport in the Twin Tiers with flights to Detroit, Orlando, and New York. Alternative for Ithaca area travelers heading south.",
      flightUrl: "https://www.flyelmira.com/",
      flightLabel: "ELM Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records in Albany. Tompkins County residents can also contact the Tompkins County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Mail, online, and in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Ithaca City Clerk or the Tompkins County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.tompkinscountyny.gov/countyclerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce decrees through the Tompkins County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default ithacaConfig;